/** What the agent remembers from past jobs: the Profile section, what the agent says using it, and its setting. */
export const memory = {
    "memory.title": "What my agent remembers",
    "memory.about": "Kept only on this phone, so your agent does not ask again. It stays when you sign out; no one else signing in here sees it.",
    "memory.empty": "Nothing yet. After a job you both signed, what your agent learned shows here.",
    "memory.area": "Your area",
    "memory.unnamed": "Someone you worked with",
    "memory.jobs.one": "{count} job together",
    "memory.jobs.other": "{count} jobs together",
    "memory.last_on": "Last job {date}",
    "memory.last_price": "Last agreed price {price}",
    "memory.they_said": "They told you",
    "memory.asked": "Asked for {trade} jobs",
    "memory.forget": "Forget",
    "memory.show.one": "See what it remembers ({count} item)",
    "memory.show.other": "See what it remembers ({count} items)",
    "memory.forget_all": "Forget everything",
    "memory.offer_detail": "From your last job, {detail}: {value}. Use it?",
    "memory.offer_detail_old": "I knew this a year ago, {detail}: {value}. Still right?",
    "memory.filled_detail": "I've put {detail}: {value}, from your last job.",
    "memory.offer_area": "From your last job, your area: {area}. Use it?",
    "memory.offer_area_old": "A year ago your area was {area}. Still right?",
    "memory.filled_area": "I've put {area} as your area, from your last job.",
    "memory.use": "Yes, use it",
    "memory.change": "Change",
    "memory.change_detail": "Change {detail}",
    "memory.change_area": "Change the area",
    "memory.answer_label": "When my agent knows an answer from my past jobs",
    "memory.answer_ask": "Ask me first",
    "memory.answer_auto": "Answer for me",
};
//# sourceMappingURL=memory.js.map